module.exports = __webpack_public_path__ + "static/media/n26.b377e8b5.jpg";